/*  ab‑video‑bucket.js  —  removes MP4s for bucket B and re‑runs after filters  */
(function () {

  function applyVideoBucketPatch () {
    const bucket =
      window.__abVideoVariant ||
      localStorage.getItem('abVideoVariant') ||
      'A';

    /* --------------------------------------------------
       bucket B  → strip the MP4 + swap thumbnail
    ---------------------------------------------------*/
    if (bucket === 'B') {
      document.querySelectorAll('.ab-video').forEach(video => {
        const img   = video.nextElementSibling?.querySelector('img');
        const thumb = video.dataset.variantImg;
        if (img && thumb) {
          img.src    = thumb;
          img.srcset = '';
        }
        video.remove();                      // no download
      });
    }

    /* --------------------------------------------------
       bucket A  → make sure newly‑injected videos play
    ---------------------------------------------------*/
    if (bucket === 'A') {
      // trigger the theme’s IntersectionObserver once
      window.dispatchEvent(new Event('scroll'));

      // any video that is still paused → load & play
      document.querySelectorAll('.ab-video').forEach(v => {
        if (v.paused) {
          v.load();
          v.play().catch(()=>{});
        }
      });
    }
  }

  /* expose for manual testing in console */
  window.applyVideoBucketPatch = applyVideoBucketPatch;

  document.addEventListener('DOMContentLoaded', applyVideoBucketPatch);
  document.addEventListener('collection:reloaded', applyVideoBucketPatch);
})();
